import { render, staticRenderFns } from "./LocationEditor.vue?vue&type=template&id=b39612ae&scoped=true"
import script from "./LocationEditor.vue?vue&type=script&lang=js"
export * from "./LocationEditor.vue?vue&type=script&lang=js"
import style0 from "./LocationEditor.vue?vue&type=style&index=0&id=b39612ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39612ae",
  null
  
)

export default component.exports